import React from 'react'
import { Outlet } from 'react-router-dom'

const PublicRoutesLayout = () => {
  return (
    <>
    <Outlet/>
    </>
  )
}

export default PublicRoutesLayout